import * as React from "react";
import type { SVGProps } from "react";
const SvgBlowDryer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.98 1.175 10.29 2.86-.01.01c.43.12.73.51.73.96v6c0 .45-.3.84-.73.96l-9.99 2.74.71 4.13c.05.29-.03.58-.22.81-.19.23-.47.36-.76.36h-1c0 1.65-1.35 3-3 3H3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1-.45 1-1H7a1 1 0 0 1-.99-.83l-.89-5.32A6.994 6.994 0 0 1 2 8.005c0-2.23 1.02-4.28 2.8-5.64a6.993 6.993 0 0 1 6.18-1.19Zm-3.66 13.67.53 3.15h1.96l-.5-2.93a7.03 7.03 0 0 1-1.99-.22Zm3.18-1.97 9.5-2.64v-4.47l-9.56-2.66a5.024 5.024 0 0 0-4.43.85A5.01 5.01 0 0 0 4 7.995c0 1.82.95 3.47 2.54 4.39 1.03.6 2.24.81 3.42.6l.54-.11Zm-1-1.37c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5Zm0-2c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBlowDryer;
